export const environment = {
  production: true,
  APIKEYGOOGLEMAPS:'AIzaSyDUbRz0ajOp3YdLg9aZIIYqSrxc20mymDI'

};
